import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Slider from '@material-ui/lab/Slider'
import Button from '@material-ui/core/Button'
import {FormattedMessage} from 'react-intl'
import {ContextConsumer} from '../Context'
import Toggle from './Toggle'

const styles = {
  card: {
    width: 400,
    alignSelf: 'center',
    position: 'relative',
    padding: 20,
  },
  title: {
    marginBottom: 16,
    fontSize: '1.2rem',
  },
  cardContent: {
    paddingTop: 0,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textField: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
  },
}

const LocalhostLoader = ({classes}) => {
  return (
    <ContextConsumer>
      {context => {
        return (
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography className={classes.title} color="textSecondary">
                <FormattedMessage id="framedLocalhost" />
              </Typography>

              <div className={classes.cardItem}>
                Width:{' '}
                <Slider
                  value={context.frameWidth}
                  min={200}
                  max={1500}
                  step={10}
                  onChange={context.handleChangeW}
                />
                <Typography variant="caption" color="textSecondary">
                  {context.frameWidth}px
                </Typography>
              </div>
              <div className={classes.cardItem}>
                Height:{' '}
                <Slider
                  value={context.frameHeight}
                  min={200}
                  max={1500}
                  step={10}
                  onChange={context.handleChangeH}
                />
                <Typography variant="caption" color="textSecondary">
                  {context.frameHeight}px
                </Typography>
              </div>

              <div className={classes.cardItem}>
                <TextField
                  id="localhost-input"
                  label={<FormattedMessage id="localhostUrl" />}
                  value={context.localhost}
                  onChange={context.handleChange('localhost')}
                  className={classes.textField}
                  type="text"
                  inputProps={{
                    autoCorrect: 'off',
                    autoCapitalize: 'none',
                  }}
                  margin="normal"
                  error={context.notify}
                />
              </div>

              <div className={classes.cardItem}>
                <Toggle
                  checked={context.localhostScrolling}
                  value="localhostScrolling"
                  label={<FormattedMessage id="localhostScrolling" />}
                  darkText
                />
              </div>

              <div className={classes.cardItem}>
                <Button
                  variant="raised"
                  size="large"
                  color="primary"
                  onClick={context.handleSendForm}
                  className={classes.button}>
                  <FormattedMessage id="open" />
                </Button>
              </div>
            </CardContent>
          </Card>
        )
      }}
    </ContextConsumer>
  )
}

LocalhostLoader.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(LocalhostLoader)



// WEBPACK FOOTER //
// ./src/components/LocalhostLoader.js